import { useCallback, useContext, useEffect, useState } from "react";
import Resizer from "react-image-file-resizer";
import { v4 as uuidv4 } from "uuid";
import { AuthContext } from "./AuthProvider";
import CONFIG from "./CONFIG";
import { storage } from "./services/firebase";
import { SnackbarContext } from "./SnackbarProvider";

const ImageUpload = ({ onImageSet }) => {
  const [file, setFile] = useState();
  const { user } = useContext(AuthContext);
  const { openErrorSnack } = useContext(SnackbarContext);

  const handleFireBaseUpload = useCallback(
    (content, imgName) => {
      const uploadTask = storage.ref(`/images/${imgName}`).put(content);
      uploadTask.on(
        "state_changed",
        (snapShot) => {},
        (err) => {
          openErrorSnack("An error occured during image upload");
        },
        () => {
          storage
            .ref("images")
            .child(imgName)
            .getDownloadURL()
            .then(onImageSet);
        }
      );
    },
    [onImageSet, openErrorSnack]
  );

  // TODO create thumbnail and main image separately

  useEffect(() => {
    if (file) {
      const name = file.name;
      const lastDot = name.lastIndexOf(".");
      const ext = name.substring(lastDot + 1);
      const imgName = `${user.uid}/${uuidv4()}.${ext}`;

      try {
        Resizer.imageFileResizer(
          file,
          CONFIG.crop.maxDimensions.width,
          CONFIG.crop.maxDimensions.height,
          "JPEG",
          CONFIG.crop.quality,
          CONFIG.crop.rotation,
          (content) => handleFireBaseUpload(content, imgName),
          "blob",
          CONFIG.crop.minDimensions.width,
          CONFIG.crop.minDimensions.height
        );
      } catch (err) {
        openErrorSnack("An error occured during image upload");
      }
    }
  }, [file, user.uid, handleFireBaseUpload, openErrorSnack]);

  const fileChangedHandler = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  return (
    <input
      type="file"
      onChange={fileChangedHandler}
      accept="image/png, image/jpeg"
    />
  );
};

export default ImageUpload;
